import { performFullNewCustomerReset } from '@/lib/performFullNewCustomerReset';
import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import AgeSmoker from '@/pages/AgeSmoker';
import Home from '@/pages/Home';
import Otp from '@/pages/Otp';
import Pdpa from '@/pages/Pdpa';
import Q7_1 from '@/pages/Q7_1';
import Q7_2 from '@/pages/Q7_2';
import Q7_3 from '@/pages/Q7_3';
import Q7_4 from '@/pages/Q7_4';
import Q7_5 from '@/pages/Q7_5';
import Q7_6 from '@/pages/Q7_6';
import DevReg from '@/pages/DevReg';
import SmokerProfile from '@/pages/SmokerProfile';
import OtherBrands from '@/pages/OtherBrands';
import Tng from '@/pages/Tng';
import TradeIn from '@/pages/TradeIn';
import TradeInContact from '@/pages/TradeInContact';
import UniqueCode from '@/pages/UniqueCode';
import ThankYou from '@/pages/ThankYou';
import LbsQ1 from '@/pages/Lbs/Q1';
import DiceQ1 from '@/pages/Dice/Q1';

function ResetClientWhenLeavingTng() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  useEffect(() => {
    const wasTng = prevPath.current === '/tng';
    const nowTng = pathname === '/tng';
    if (wasTng && !nowTng) {
      performFullNewCustomerReset();
    }
    prevPath.current = pathname;
  }, [pathname]);
  return null;
}

function Router() {
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/age_smoker', element: <AgeSmoker /> },
    { path: '/pdpa', element: <Pdpa /> },
    { path: '/uniquecode', element: <UniqueCode /> },
    { path: '/otp', element: <Otp /> },
    { path: '/smokerprofile', element: <SmokerProfile /> },
    { path: '/otherbrands', element: <OtherBrands /> },
    { path: '/lbs/q1', element: <LbsQ1 /> },
    { path: '/dice/q1', element: <DiceQ1 /> },
    { path: '/7_1', element: <Q7_1 /> },
    { path: '/7_2', element: <Q7_2 /> },
    { path: '/7_3', element: <Q7_3 /> },
    { path: '/7_4', element: <Q7_4 /> },
    { path: '/7_5', element: <Q7_5 /> },
    { path: '/7_6', element: <Q7_6 /> },
    { path: '/devreg', element: <DevReg /> },
    { path: '/tradein', element: <TradeIn /> },
    { path: '/tradeincontact', element: <TradeInContact /> },
    { path: '/tng', element: <Tng /> },
    { path: '/thankyou', element: <ThankYou /> },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
  return (
    <>
      <ResetClientWhenLeavingTng />
      {routes}
    </>
  );
}

export default Router;
